export default function SectionTitle(props: any) {
  return <div className="make-font-600 text-3xl sm:text-5xl text-left mb-4 sm:mb-8">{props.children}</div>;
}